<template>
  <div>
    <div class="pop-wrapper">
      <div class="dim" @click="closePopup"></div>
      <div class="pop-inner">
        <div>
          <img
            src="@/assets/img/newGlobal/common/close.png"
            alt="close"
            class="pop-close"
            @click="closePopup"
          />
          <div class="content">
            <div class="m">
              <img :src="imgM" alt="Image" />
            </div>
            <div class="p">
              <img :src="imgP" alt="Image" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imgP: {
      type: String,
      default: "",
    },
    imgM: {
      type: String,
      default: "",
    },
  },
  mounted() {
    document.body.style.overflow = "hidden";
  },
  methods: {
    closePopup() {
      this.$emit("closeImgView");
      document.body.style.overflow = "auto";
    },
  },
};
</script>

<style lang="scss" scoped>
img {
  width: 100%;
}

.pop-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  z-index: 2;

  .dim {
    position: fixed;
    top: inherit;
    left: inherit;
    width: inherit;
    height: inherit;
    background-color: rgba($color: #000000, $alpha: 0.5);
  }

  .pop-inner {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 1400px;
    margin: 0 auto;
    padding: 25px;

    @media screen and (min-width: 768px) {
      padding: 25px 50px;
    }
  }

  .pop-close {
    width: 30px;
    height: 30px;
    margin-left: auto;
    margin-bottom: 20px;
    position: relative;
    z-index: 1;
    cursor: pointer;
  }

  .content {
    position: relative;
    z-index: 1;
  }
}

.p {
  display: none;
}

@media screen and (min-width: 768px) {
  .m {
    display: none;
  }

  .p {
    display: block;
  }
}
</style>
